/**
 * Idiomas soportados por el panel. El orden de este array es el que se muestra
 * en el selector de Configuración, con el castellano primero por ser el idioma
 * de origen de todos los textos (y el fallback cuando falta una clave).
 */
export const IDIOMAS = ['es', 'en', 'pt', 'gl', 'ca', 'eu'] as const;

export type Idioma = (typeof IDIOMAS)[number];

export const IDIOMA_POR_DEFECTO: Idioma = 'es';

/** Nombre de cada idioma escrito en ese mismo idioma (endónimo). */
export const NOMBRES_IDIOMA: Record<Idioma, string> = {
    es: 'Español',
    en: 'English',
    pt: 'Português',
    gl: 'Galego',
    ca: 'Català',
    eu: 'Euskara',
};

/**
 * Locale BCP 47 que se pasa a las APIs `Intl` / `toLocaleString`. El euskera y el
 * gallego van sin región porque `Intl` ya resuelve `eu` y `gl` por su cuenta; el
 * portugués se fija a `pt-PT` (no `pt-BR`) por ser el mercado objetivo.
 */
export const LOCALE_INTL: Record<Idioma, string> = {
    es: 'es-ES',
    en: 'en-GB',
    pt: 'pt-PT',
    gl: 'gl',
    ca: 'ca-ES',
    eu: 'eu',
};

export function esIdiomaSoportado(valor: unknown): valor is Idioma {
    return typeof valor === 'string' && (IDIOMAS as readonly string[]).includes(valor);
}
